import { IListContentProps } from '../interfaces/interfaces';
import NoRecommendedItems from './no-recommended-items';
import ListContent from '../content/content';
import { getIsAuthenticated } from '../../../domain/hidden-data-provider';
import { MyRecommendedLoginPopup } from './my-recommended-login-popup';
import { ProductsIOwnLoginPopup } from '../panels/products-i-own/login-popup';
import { useAppSelector } from '../data/store';

/**
 * My recommended products.
 * https://wavesaudio.atlassian.net/browse/DSWEB-1934
 */
const MyRecommendedListContent = (props: IListContentProps) => {

    const productsInitial = useAppSelector(store => store.productsInitial);

    const showPopUp = !getIsAuthenticated();
    const hasItems = productsInitial.length > 0;

    return (
        <>
            { !hasItems && <NoRecommendedItems /> }

            { hasItems && <ListContent products={ props.products } width={ props.width } hasPanels={ hasItems } /> }

            { showPopUp && <MyRecommendedLoginPopup /> }

            { hasItems && <ProductsIOwnLoginPopup /> }
        </>
    )
};

export default MyRecommendedListContent;